/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  DeleteUserNotificationTopicParams,
  UserNotificationTopicCreateRequest,
  UserNotificationTopicCreateResponse,
  UserNotificationTopicDeleteResponse,
  UserNotificationTopicListResponse,
  UserNotificationTopicUpdateRequest,
  UserNotificationTopicUpdateResponse
} from './index.schemas';

import { useCustomInstance } from '../staverton.openapi.axios';





export const useListUserNotificationTopicsHook = () => {
        const listUserNotificationTopics = useCustomInstance<UserNotificationTopicListResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return listUserNotificationTopics(
          {url: `/UserNotificationTopic/List`, method: 'GET', signal
    },
          );
        }, [listUserNotificationTopics])
      }
    

export const getListUserNotificationTopicsQueryKey = () => {
    return [`/UserNotificationTopic/List`] as const;
    }

    
export const useListUserNotificationTopicsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUserNotificationTopicsQueryKey();

  const listUserNotificationTopics =  useListUserNotificationTopicsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>> = ({ signal }) => listUserNotificationTopics(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUserNotificationTopicsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>>
export type ListUserNotificationTopicsQueryError = unknown


export function useListUserNotificationTopics<TData = Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserNotificationTopics<TData = Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserNotificationTopics<TData = Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListUserNotificationTopics<TData = Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserNotificationTopicsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListUserNotificationTopicsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useCreateUserNotificationTopicHook = () => {
        const createUserNotificationTopic = useCustomInstance<UserNotificationTopicCreateResponse>();

        return useCallback((
    userNotificationTopicCreateRequest: UserNotificationTopicCreateRequest,
 signal?: AbortSignal
) => {
        return createUserNotificationTopic(
          {url: `/UserNotificationTopic/Create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userNotificationTopicCreateRequest, signal
    },
          );
        }, [createUserNotificationTopic])
      }
    


export const useCreateUserNotificationTopicMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateUserNotificationTopicHook>>>, TError,{data: UserNotificationTopicCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateUserNotificationTopicHook>>>, TError,{data: UserNotificationTopicCreateRequest}, TContext> => {

const mutationKey = ['createUserNotificationTopic'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createUserNotificationTopic =  useCreateUserNotificationTopicHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateUserNotificationTopicHook>>>, {data: UserNotificationTopicCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createUserNotificationTopic(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserNotificationTopicMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateUserNotificationTopicHook>>>>
    export type CreateUserNotificationTopicMutationBody = UserNotificationTopicCreateRequest
    export type CreateUserNotificationTopicMutationError = unknown

    export const useCreateUserNotificationTopic = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateUserNotificationTopicHook>>>, TError,{data: UserNotificationTopicCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateUserNotificationTopicHook>>>,
        TError,
        {data: UserNotificationTopicCreateRequest},
        TContext
      > => {

      const mutationOptions = useCreateUserNotificationTopicMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useUpdateUserNotificationTopicHook = () => {
        const updateUserNotificationTopic = useCustomInstance<UserNotificationTopicUpdateResponse>();

        return useCallback((
    userNotificationTopicUpdateRequest: UserNotificationTopicUpdateRequest,
 ) => {
        return updateUserNotificationTopic(
          {url: `/UserNotificationTopic/Update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userNotificationTopicUpdateRequest
    },
          );
        }, [updateUserNotificationTopic])
      }
    


export const useUpdateUserNotificationTopicMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserNotificationTopicHook>>>, TError,{data: UserNotificationTopicUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserNotificationTopicHook>>>, TError,{data: UserNotificationTopicUpdateRequest}, TContext> => {

const mutationKey = ['updateUserNotificationTopic'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateUserNotificationTopic =  useUpdateUserNotificationTopicHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateUserNotificationTopicHook>>>, {data: UserNotificationTopicUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateUserNotificationTopic(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserNotificationTopicMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateUserNotificationTopicHook>>>>
    export type UpdateUserNotificationTopicMutationBody = UserNotificationTopicUpdateRequest
    export type UpdateUserNotificationTopicMutationError = unknown

    export const useUpdateUserNotificationTopic = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserNotificationTopicHook>>>, TError,{data: UserNotificationTopicUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateUserNotificationTopicHook>>>,
        TError,
        {data: UserNotificationTopicUpdateRequest},
        TContext
      > => {

      const mutationOptions = useUpdateUserNotificationTopicMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useDeleteUserNotificationTopicHook = () => {
        const deleteUserNotificationTopic = useCustomInstance<UserNotificationTopicDeleteResponse>();

        return useCallback((
    params?: DeleteUserNotificationTopicParams,
 ) => {
        return deleteUserNotificationTopic(
          {url: `/UserNotificationTopic/Delete`, method: 'DELETE',
        params
    },
          );
        }, [deleteUserNotificationTopic])
      }
    


export const useDeleteUserNotificationTopicMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserNotificationTopicHook>>>, TError,{params?: DeleteUserNotificationTopicParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserNotificationTopicHook>>>, TError,{params?: DeleteUserNotificationTopicParams}, TContext> => {

const mutationKey = ['deleteUserNotificationTopic'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteUserNotificationTopic =  useDeleteUserNotificationTopicHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteUserNotificationTopicHook>>>, {params?: DeleteUserNotificationTopicParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteUserNotificationTopic(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserNotificationTopicMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteUserNotificationTopicHook>>>>
    
    export type DeleteUserNotificationTopicMutationError = unknown

    export const useDeleteUserNotificationTopic = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserNotificationTopicHook>>>, TError,{params?: DeleteUserNotificationTopicParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteUserNotificationTopicHook>>>,
        TError,
        {params?: DeleteUserNotificationTopicParams},
        TContext
      > => {

      const mutationOptions = useDeleteUserNotificationTopicMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    